import {Component, Input, OnInit} from '@angular/core';
import {CampaignForm} from '@app/@core/advertising/campaign/campaign-form';
import {CampaignDraft} from "@app/@core/advertising/campaign/campaign-draft";
import {ConfigService} from "@app/@core/@config/config.service";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-campaign-address[campaignForm]',
  templateUrl: './campaign-address.component.html',
  styleUrls: ['./campaign-address.component.scss']
})
export class CampaignAddressComponent implements OnInit {
  @Input() campaignForm!: FormGroup;

  constructor(public configService: ConfigService) { }

  ngOnInit(): void {
  }
}
